import { render, staticRenderFns } from "./RelatorioComprasPosto.vue?vue&type=template&id=4bf1f9bc&"
import script from "./RelatorioComprasPosto.vue?vue&type=script&lang=js&"
export * from "./RelatorioComprasPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports